/**
 * UpgradeCard — secondary amber-outline upgrade prompt.
 * Used in State 1 (below the assessment CTA) and State 2 (below the featured
 * free course). Visually lower weight than the primary CTAs — white background,
 * amber outline button only (no filled gradient background on the card).
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../utils/constants';

export const UpgradeCard: React.FC = () => (
  <div
    className="db-fade-up flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4"
    style={{
      background: '#fff',
      border: '1.5px solid #e8e8ee',
      borderRadius: '14px',
      padding: '20px 24px',
    }}
  >
    <div className="flex items-center gap-3 flex-1 min-w-0">
      <span
        className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full font-montserrat font-bold text-xs text-white flex-shrink-0"
        style={{ background: 'linear-gradient(135deg, #f59e0b, #f97316)' }}
      >
        ⚡ Premium
      </span>
      <p className="font-open-sans text-sm text-neutral-800 leading-snug">
        Already know you want full access? Skip straight to Premium and unlock everything from day one.
      </p>
    </div>
    <Link
      to={ROUTES.pricing}
      className="btn-amber-outline flex-shrink-0 inline-flex items-center gap-1.5 px-5 py-2 rounded-full font-montserrat font-bold text-sm"
      style={{ whiteSpace: 'nowrap' }}
    >
      Upgrade to Premium →
    </Link>
  </div>
);
